import { SQDCActionStatus } from "@/graphql";
import type { Maybe } from "graphql/jsutils/Maybe";
import { DateTime } from "luxon";

export default function getBadgeColor(
  status: Maybe<number>,
  deadline: Maybe<string>,
): string | undefined {
  if (status !== 4) {
    if (deadline && DateTime.fromISO(deadline).startOf("day") < DateTime.now().startOf("day")) {
      return "var(--p-danger-color)";
    }

    if (deadline && DateTime.fromISO(deadline).hasSame(DateTime.now(), "day")) {
      return "var(--p-yellow-200)";
    }
    return "#ffffff00";
  }
  return undefined;
}

export function getBadgeColorNew(
  status: Maybe<SQDCActionStatus>,
  deadline: Maybe<string>,
): string | undefined {
  if (status !== SQDCActionStatus.ACT) {
    if (deadline && DateTime.fromISO(deadline).startOf("day") < DateTime.now().startOf("day")) {
      return "var(--p-danger-color)";
    }

    if (deadline && DateTime.fromISO(deadline).hasSame(DateTime.now(), "day")) {
      return "var(--p-warn-color)";
    }
    return "#ffffff00";
  }
  return undefined;
}
